var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIngles24X24(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_380_4574)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#1C61B1"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.1126,
    height: 5.56776,
    transform: "matrix(0.755929 0.654654 -0.359211 0.933257 0.808594 -1.20605)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.6423,
    height: 1.85592,
    transform: "matrix(0.755929 0.654654 -0.359211 0.933257 -0.210938 1.375)",
    fill: "#FF444B"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.5975,
    height: 5.56776,
    transform: "matrix(0.755929 -0.654654 0.359211 0.933257 -1.19141 19.9229)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.6729,
    height: 1.85592,
    transform: "matrix(0.755929 -0.654654 0.359211 0.933257 -0.210938 22.5381)",
    fill: "#FF444B"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.551,
    height: 5.56776,
    transform: "matrix(-0.755929 -0.654654 0.359211 -0.933257 23.207 25.1191)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 17.1687,
    height: 1.85592,
    transform: "matrix(-0.755929 -0.654654 0.359211 -0.933257 24.2266 22.5381)",
    fill: "#FF444B"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.6786,
    height: 5.56776,
    transform: "matrix(-0.755929 0.654654 -0.359211 -0.933257 25.207 3.99023)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.6942,
    height: 1.85592,
    transform: "matrix(-0.755929 0.654654 -0.359211 -0.933257 24.2266 1.375)",
    fill: "#FF444B"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 8,
    width: 24,
    height: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.667,
    width: 24,
    height: 5.33333,
    transform: "rotate(90 14.667 0)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.333,
    width: 24,
    height: 2.66667,
    transform: "rotate(90 13.333 0)",
    fill: "#FF444B"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 10,
    width: 24,
    height: 4,
    fill: "#FF444B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_380_4574"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIngles24X24);
export default __webpack_public_path__ + "static/media/INGLES_24X24.2e0fcbb161e155794b0f391b727d1e65.svg";
export { ForwardRef as ReactComponent };